// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","content":"C_nxp","filAriane":"_2AvkA","subLink":"_1qnUx","currentPage":"_16FQZ","article":"_3Thzp","publicationDate":"_3JB5G"};